/** Pure conversion contract; account authorization and writes remain in the caller. */
export interface CalendarInvitationCodec {
  parse(
    content: string,
    calendarId: string
  ): Array<{
    uid: string;
    startAt: string;
    isAllDay: boolean;
    payload: Record<string, unknown>;
  }>;
}

let loadCodec: (() => Promise<CalendarInvitationCodec>) | undefined;

/** The shell owns loading Calendar's public entry; apps never import each other. */
export function setCalendarInvitationCodecLoader(
  loader: () => Promise<CalendarInvitationCodec>
): void {
  loadCodec = loader;
}

export async function getCalendarInvitationCodec(): Promise<CalendarInvitationCodec> {
  if (!loadCodec) throw new Error('Calendar invitation conversion is unavailable');
  return loadCodec();
}
